'use strict';

var modulo = require('./modulo');

var msPerDay = require('../helpers/timeConstants').msPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.2

module.exports = function TimeWithinDay(t) {
	return modulo(t, msPerDay);
};




//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/TimeWithinDay.js
// module id = 1327
// module chunks = 0